import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import logger from './utils/logger'; // logger is not used here, can be removed if not needed elsewhere

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        //console.log('ServiceWorker registration successful');
        
        registration.update();
        
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); 
        
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                const userAgent = navigator.userAgent.toLowerCase();
                const isCrawler = /bot|crawler|spider|googlebot|bingbot|yahoo|duckduckbot|baiduspider|yandex|sogou|exabot|facebookexternalhit/i.test(userAgent);
                
                if (isCrawler) {
                  window.location.reload();
                } else {
                  console.log('New content is available; please refresh.');
                  if (window.confirm('New version of the app is available! Reload to update?')) {
                    window.location.reload();
                  }
                }
              }
            });
          }
        });
      })
      .catch(err => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}


// No async initializeApp needed anymore for auth token, AuthProvider handles it.
// Render the app directly.
root.render(
  
    <App />
);

reportWebVitals();